import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=37d4ae5a&scoped=true&"
import script from "./Abnormal.vue?vue&type=script&lang=js&"
export * from "./Abnormal.vue?vue&type=script&lang=js&"
import style0 from "./Abnormal.vue?vue&type=style&index=0&id=37d4ae5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4ae5a",
  null
  
)

export default component.exports